export const errorResponse = (error, cb) => {
  console.log(error, 'errorresponse')
  if (error.response) {
    if (error.response.status === 401) {
      cb(null, { redirect: true })
    } else if (error.response.status === 403) {
      cb(null, error.response)
    } else if (error.response.status === 422) {
      cb(null, { message: error.response.data.errors[0].msg })
    } else if (error.response.data && error.response.data.message) {
      cb(null, { message: error.response.data.message })
    } else {
      const message =
        error.response.data?.message || 'An error occurred. Please refresh the website.'
      alert(message + ' harap refresh website')
      // window.location.reload()
      // Also call cb with the error so it doesn't hang
      cb(null, { message })
    }
  } else {
    alert(error.message)
    // window.location.reload()
    cb(null, { message: error.message })
  }
}
